/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Theme_LightInputs */



/**
* | output |
* | --- |
* | "Light" |
*
* @param {Settings_Theme_LightInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_theme_light = /** @type {((inputs?: Settings_Theme_LightInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Theme_LightInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Licht")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Clair")
	return /** @type {LocalizedString} */ ("Light")
});